import PropTypes from "prop-types";
import React, {useState} from "react";
import {
  Row,
  Col,
  Alert,
  Card,
  CardBody,
  Container,
  FormFeedback,
  Input,
  Label,
  Form,
} from "reactstrap";
import Config from "config";
//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import { Link , useNavigate } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import background from "../../assets/images/guyane.png";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// action
import { userForgetPassword } from "../../store/actions";

// import images
import profile from "../../assets/images/profile-img.png";
import logo from "../../assets/images/logo.svg";
import logoW from "../../assets/images/logo_white_seule.png";
import logoB from "../../assets/images/logo_black_seule.png";
import domLogo from "../../assets/images/logo_white.png";
import logoBlack from "../../assets/images/logo_black.png";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

const ForgetPasswordPage = (props) => {
  const layout = localStorage.getItem("layoutMode");
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  const navigate = useNavigate();
  const [selectedEmail,setSelectedEmail] = useState("");
  const handleEmailChange = (e) => {
    setSelectedEmail(e.target.value);
  };
  //meta title
  document.title = "DOMCOM | Mot de passe oublié";

  const dispatch = useDispatch();

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Merci de renseigner votre adresse Email"),
    }),
    onSubmit: (values) => {
      dispatch(userForgetPassword(values, props.history));
    },
  });

  const selectForgotPasswordState = (state) => state.ForgetPassword;
  const ForgotPasswordProperties = createSelector(
    selectForgotPasswordState,
    (forgetPassword) => ({
      forgetError: forgetPassword.forgetError,
      forgetSuccessMsg: forgetPassword.forgetSuccessMsg,
    })
  );

  const { forgetError, forgetSuccessMsg } = useSelector(
    ForgotPasswordProperties
  );
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (selectedEmail.trim() !== "") {
      try {
        const response = await fetch(`https://www.fluxod.com/${api}/reset_password?email=${selectedEmail}`, {
          method: "POST",
          body: JSON.stringify({})
        });

        if (response.ok) {
          console.log("POST request successful");
          const responseData = await response.json();
          toast.success(responseData?.message);
        } else {
          console.error("POST request failed");
          const responseData = await response.json();

          if (responseData && responseData.pme_validation) {
            const errors =
              responseData?.pme_validation
            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }else{
      toast.error("Veuillez renseigner votre adresse email.");
    }
    
    // }
  };
  return (
    <React.Fragment>
      <div style={{
        backgroundImage: `url(${background})`, backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        width: '100vw',
        height: '100vh'
      }}>
        <div className="account-pages" style={{ paddingTop: "8em" }}>
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary-subtle">
                  <Row>
                      <Col className="col-6">
                      <div className="p-4">
                        <h5 className="text-primary">Bienvenue</h5>
                        <p>Réinitialisation de votre mot de passe.</p>
                      </div>
                    </Col>
                      <Col className="col-5">
                        <img
                          src={layout === "dark" ? domLogo : logoBlack}
                          alt="logo"
                          className="img-fluid mt-4"
                        />
                      </Col>
                      <Col className="col-1">&nbsp;</Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div className="p-2">
                    {forgetError && forgetError ? (
                      <Alert color="danger" style={{ marginTop: "13px" }}>
                        {forgetError}
                      </Alert>
                    ) : null}
                    {forgetSuccessMsg ? (
                      <Alert color="success" style={{ marginTop: "13px" }}>
                        {forgetSuccessMsg}
                      </Alert>
                    ) : null}

                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault();
                        handleSubmit(e);
                        return false;
                      }}
                    >
                      <div className="mb-3">
                        <Label className="form-label">Email</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Entrer votre adresse email"
                          type="email"
                          onChange={(event) => {
                            validation.handleChange(event);
                            handleEmailChange(event);
                          }} 
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email
                              ? true
                              : false
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">
                            {validation.errors.email}
                          </FormFeedback>
                        ) : null}
                      </div>
                      <Row className="mb-3">
                        <Col className="text-end">
                          <button
                            className="btn btn-primary w-md "
                            type="submit"
                          >
                            Réinitialiser
                          </button>
                        </Col>
                      </Row>
                      <Row>
                          <div className="mt-3 text-center">
                            <p>
                              <Link to={`${backUrl}/login`} className="text-dark">
                                Retour à la page d'authentification{" "}
                                <i className="bx bx-home h2" />
                              </Link>
                            </p>
                          </div>
                      </Row>
                    </Form>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        </div>
      </div>
      <ToastContainer />
    </React.Fragment>
  );
};

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
};

export default withRouter(ForgetPasswordPage);
